import { FC } from 'react';
import styles from './MenuItem.module.scss';
import { arrowMenu } from '../../../assets';
import { useNavigate } from 'react-router';

interface MenuITemProps {
    icon?: string;
    title: string;
    link?: string;
    onCLick?: () => void;
}

const MenuItem: FC<MenuITemProps> = ({ icon, title, link, onCLick }) => {
    const navigate = useNavigate();

    return (
        <div
            className={styles.menuItem}
            onClick={() => {
                link && !onCLick && navigate(link);
                onCLick && onCLick();
            }}>
            <div className={styles.title}>
                {icon && (
                    <img
                        src={icon}
                        alt=""
                    />
                )}
                <p>{title}</p>
            </div>
            <img
                src={arrowMenu}
                alt=""
            />
        </div>
    );
};

export default MenuItem;
